<template>
  <RoleDetail
      :title="pageTitle"
      :return-destination="'/PermissionRole'"
      :show-edit-button="$isFunctionShown(define.PermissionKeys.Account.PermissionRole.Detail.NEW)"
      :disable-edit-button="$isFunctionDisabled(define.PermissionKeys.Account.PermissionRole.Detail.EDIT)"
      :show-delete-button="$isFunctionShown(define.PermissionKeys.Account.PermissionRole.Detail.DELETE)"
      :disable-delete-button="$isFunctionDisabled(define.PermissionKeys.Account.PermissionRole.Detail.DELETE)"
      :show-back-button="showBackButton"
      :show-action-button="showActionButton"
      :show-save-button="showSaveButton"
      :disable-save-button="disableSaveButton"
      :show-cancel-button="showCancelButton"
      :bdmd-id="originData.name"
      :store-path="storePath"
      :path-parameter="['uuid']"
      :is-permission-role="true"
      :sorted-list="sortedList"
      :can-move-data="canMoveData"
      bdmd-title="ロール名称"
      router-path="/PermissionRole/"
      @edit="edit"
      @delete="remove"
      @save="save"
      @cancel="cancel">
    <BaseTableDetail
        slot="list"
        class="permissionroledetail-table-list"
        :border="true"
        :table-set-list="tableSetList"
        :display-item="detailData"
        :editable="editable" />
  </RoleDetail>
</template>
<style scoped>
/* 編集が可、不可、可のとき */
 /* 左 - 不要 */
 /* 中 */
.permissionroledetail-table-list ::v-deep .disableBorderModify3 .el-radio-button:not(:last-child):not(:first-child) .el-radio-button__inner{
  border-right-style: none;
  border-right-width: 0px;
}
 /* 右 */
.permissionroledetail-table-list ::v-deep .disableBorderModify3 .el-radio-button:last-child .el-radio-button__inner{
  border-left-style: solid;
  border-left-width: 1px;
}

/* 編集が不可、可、可のとき */
 /* 左 */
.permissionroledetail-table-list ::v-deep .disableBorderModify4 .el-radio-button:first-child .el-radio-button__inner{
  border-right-style: none;
  border-right-width: 0px;
}
 /* 中 */
.permissionroledetail-table-list ::v-deep .disableBorderModify4 .el-radio-button:not(:last-child):not(:first-child) .el-radio-button__inner{
  border-left-style: solid;
  border-left-width: 1px;
}
 /* 右 - 不要  */
</style>
<script>
import _ from 'lodash'
import { mapState, mapMutations, mapGetters } from 'vuex'
import store from '@/store/index'

import * as define from '@/define'
import * as query from '@/queries/permissionRole'
import common from '@/utils/common'
import * as config from '@/config'
import message from '@/utils/message'
import permissionRole from '@/store/pages/permissionRole'

import x from '@/components/mixins/mixin'
import confirmDiscardOnLeave from '@/components/mixins/confirmDiscardOnLeave'
import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import RoleDetail from '@/components/pages/account/RoleDetail'
import BaseTableDetail from '@/components/molecules/BaseTableDetail'
import detailUtil from '@/components/mixins/detailUtil'

const EDITABLE = Object.freeze({
  [define.ROLE_MODE.NORMAL]: Object.freeze({}),
  [define.ROLE_MODE.EDIT]: Object.freeze({ name: true, permissionValues: true }),
  [define.ROLE_MODE.NEW]: Object.freeze({ name: true, permissionValues: true })
})

const returnDestination = '/PermissionRole'
const returnDestinationTitle = 'CCS - 権限ロール一覧'

// 権限ロール項目の「edit_type」による編集可否
const EDITABLE_ROLETYPE = Object.freeze({
  1: { disp: true, edit: true, nonDisp: true },
  2: { disp: true, edit: true, nonDisp: false },
  3: { disp: true, edit: false, nonDisp: true },
  4: { disp: false, edit: true, nonDisp: true },
  5: { disp: true, edit: false, nonDisp: false }, // 登録しない想定
  6: { disp: false, edit: true, nonDisp: false }, // 登録しない想定
  7: { disp: false, edit: false, nonDisp: true }, // 登録しない想定
  8: { disp: false, edit: false, nonDisp: false } // 基本的に不使用を想定。ツリーとしてのみ使用したいときに使用。
})

const customValidationRules = (v) => {
  v.$validator.extend('customRequiredChild', {
    getMessage: () => {
      return '親機能を使用する場合、選択は必須です。'
    },
    validate: (data, [ key ]) => {
      // edit_typeが「2」である
      const targetPermission = v.detailData.permissions.find((element) => element.config.key === key)
      if (targetPermission.config.editType === 2) {
        // 値が未選択である
        if (v.detailData.permissionValues[key] === -1) {
          // 親の項目が「0」または「1」である
          if ([ 0, 1 ].includes(v.detailData.permissionValues[targetPermission.config.parent.key])) {
            return false
          }
        }
      }
      return true
    }
  })
}

export default {
  name: 'PermissionRoleDetail',
  components: {
    RoleDetail,
    BaseTableDetail
  },
  mixins: [ x, confirmDiscardOnLeave, detailUtil ],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      detailData: {},
      originData: {},
      isChanged: false,
      reservedTransition: false,
      canMoveData: false
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      size: (state) => state.PermissionRole.size,
      mode: (state) => state.PermissionRole.mode
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    storePath () {
      return 'PermissionRole'
    },
    pageTitle () {
      return this.mode === define.ROLE_MODE.NEW
        ? '権限ロール登録'
        : '権限ロール詳細'
    },
    tableSetList () {
      return [
        {
          label: 'ロール名称',
          properties: [
            {
              path: 'name', type: 'String', elementType: ELEMENT_TYPE.INPUT, editableId: 'name',
              validateRule: 'required|max:100', validateAs: 'ロール名称'
            }
          ]
        },
        {
          label: '権限',
          properties: [
            {
              path: (val) => {
                const setPath = (array) => {
                  return _.chain(array)
                    .forEach((config) => {
                      config.validateRule = `customRequiredChild:${config.key}`
                      config.path = `permissionValues.${config.key}`
                      config.onChange = this.onChangePermission
                      config.class = [ 3, 4 ].includes(config.editType) ? `disableBorderModify${config.editType}` : ''
                      setPath(config.children)
                    })
                    .sortBy('displayOrder')
                    .value()
                }
                return _.chain(this.detailData.permissions)
                  .map('config')
                  .filter((val) => _.get(val, 'parent') == null)
                  .thru((val) => {
                    return setPath(val)
                  })
                  .value()
              },
              type: 'String', elementType: ELEMENT_TYPE.TREE, editableId: 'permissionValues',
              id: 'key', label: 'name',
              selectCode: (val) => {
                // 権限項目の種類を見て選択可能かを判断
                if (val.data) {
                  const editable = EDITABLE_ROLETYPE[val.data.editType]
                  return [
                    { code: 0, name: '表示のみ', disabled: !editable.disp },
                    { code: 1, name: '表示 および 編集/実行', disabled: !editable.edit },
                    { code: 2, name: '非表示', disabled: !editable.nonDisp }
                  ]
                } else { return [] }
              }
            }
          ]
        }
      ]
    },
    sortedList () {
      return this.$store.getters['sortedList'](this.storePath, this.sortCondition('permissionRoleList'))
    },
    showBackButton () {
      return this.mode === define.ROLE_MODE.NORMAL && !this.$isFunctionDisabled(define.PermissionKeys.Account.PermissionRole.LIST)
    },
    showActionButton () {
      return this.mode === define.ROLE_MODE.NORMAL
    },
    showSaveButton () {
      return this.mode !== define.ROLE_MODE.NORMAL
    },
    disableSaveButton () {
      return !this.isChanged
    },
    showCancelButton () {
      return this.mode !== define.ROLE_MODE.NORMAL
    },
    editable () {
      return EDITABLE[this.mode]
    }
  },
  watch: {
    detailData: {
      handler: function (val, oldVal) {
        this.isChanged = this.$_ConfirmDiscardOnLeave_isChanged()
      },
      deep: true
    },
    mode (val) {
      // 既に遷移予定である場合、制御不要
      if (!this.reservedTransition) {
        const route = this.$route
        if (val === define.ROLE_MODE.NORMAL &&
          (route.params && route.params.id === '0')) {
          this.$router.push({ path: returnDestination })
        }
        // ページタイトルの再設定
        document.title = `CCS - ${this.pageTitle}`
      }
    }
  },
  async created () {
    // ページタイトルの設定
    document.title = `CCS - ${this.pageTitle}`
    // カスタムバリデーションルールを追加
    customValidationRules(this)

    window.addEventListener('beforeunload', this.onBeforeUnload)

    try {
      await this.getDetailData()
      if (this.mode === define.ROLE_MODE.NEW) {
        this.originData = _.cloneDeep(this.detailData)
        this.$_ConfirmDiscardOnLeave_watchStart(this.detailData, '権限ロール登録を中止しますか？')
      }
    } catch (error) {
      this.$notify.error({ error: error })
      throw error
    }
  },
  destroyed () {
    window.removeEventListener('beforeunload', this.onBeforeUnload)
  },
  beforeRouteEnter (to, from, next) {
    // [beforeRouteEnter]ではvueコンポーネントの生成が未完であるため、「this.$store」で呼び出しができない。
    // そのため、storeのあるファイルをImportし、直接参照している。
    if (to.params && to.params.id === '0' && store.state.PermissionRole.mode !== define.ROLE_MODE.NEW) {
      // 履歴の操作により、入ってきたとき、storeが正しくないので編集
      store.dispatch({ type: 'set', states: { 'PermissionRole/mode': define.ROLE_MODE.NEW } })
    } else if (to.params && to.params.id !== '0' && store.state.PermissionRole.mode !== define.ROLE_MODE.NORMAL) {
      next(vm => {
        vm.updateMode(define.ROLE_MODE.NORMAL)
      })
      return
    }

    next()
  },
  async beforeRouteUpdate (to, from, next) {
    // 新規作成完了後
    if (from.params && from.params.id === '0') {
      // 新規登録完了時、戻る等でいきなり新規作成とならないように履歴を修正
      document.title = returnDestinationTitle
      history.replaceState(null, null, returnDestination)
    }
    // ページ送りにより変更した対象アカウントのデータ取得（ページ送り時のモードは通常モードに制御されているため、初期化不要）
    next()
    await this.getDetailData()
  },
  beforeRouteLeave (to, from, next) {
    // 別ページへ移動する場合、modeを初期化する.
    this.reservedTransition = true
    this.updateMode(define.ROLE_MODE.NORMAL)

    next()
  },
  methods: {
    ...mapMutations('PermissionRole', {
      updateListItem: 'update',
      deleteListItem: 'delete'
    }),
    edit () {
      this.updateMode(define.ROLE_MODE.EDIT)
      this.originData = _.cloneDeep(this.detailData)

      this.$_ConfirmDiscardOnLeave_watchStart(this.detailData)
    },
    remove () {
      this.$confirm('権限ロールを削除しますか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(async () => {
        try {
          this.$loadingService.show()
          await this.deleteRoleApi()
          this.deleteListItem(this.detailData.uuid)
          this.$notify.success('権限ロールを削除しました。')
          this.updateMode(define.ROLE_MODE.NORMAL)
          this.$router.push({ path: returnDestination })
          // 最新権限ロールの取得（アカウントの検索条件用）
          await permissionRole.getPermissionRoleOptions(true)
        } catch (error) {
          const data = _.get(error, 'response.data')
          if (data == null) {
            common.addError(error, { msg: message.MSG_502() })
          } else {
            common.addError(error, { msg: message.MSG_517() })
          }
          this.$notify.error({ error: error })
          throw error
        } finally {
          this.$loadingService.close()
        }
      }).catch(() => {})
    },
    async save () {
      // ツリーに表示されていない権限はバリデーションチェックが走らないため、
      // 独自メソッドでチェックを行いNGがあれば、対象の階層まで開く。
      // 開いたらチェック処理はバリデーションチェックで行い、メッセージを表示する。
      if (!await this.customRequiredEntirety()) {
        return
      } else {
        if (!await this.$validator.validateAll()) {
          // バリデーションエラーあり
          return
        }
      }

      this.$confirm('保存しますか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(async () => {
        try {
          this.$loadingService.show()
          const res = await this.updateOrInsertPermissionRoleApi()
          this.$_ConfirmDiscardOnLeave_watchEnd()
          this.isChanged = false
          if (this.mode === define.ROLE_MODE.NEW) {
            this.reservedTransition = true
            this.updateMode(define.ROLE_MODE.NORMAL)
            this.$router.push({ path: `/permissionrole/${res.data.uuid}` })
          } else {
            this.updateMode(define.ROLE_MODE.NORMAL)
            await this.getDetailData(true)
          }
          this.$notify.success('保存しました。')
          // 最新権限ロールの取得（アカウントの検索条件用）
          await permissionRole.getPermissionRoleOptions(true)
        } catch (error) {
          const data = _.get(error, 'response.data')
          if (data == null) {
            common.addError(error, { msg: message.MSG_502() })
          } else if (this.hasLastUpdatedError(error)) {
            common.addError(error, { msg: message.MSG_530() })
          } else {
            if (this.mode === define.ROLE_MODE.NEW) {
              common.addError(error, { msg: message.MSG_511() })
            } else {
              common.addError(error, { msg: message.MSG_512() })
            }
          }
          this.$notify.error({ error: error })
          throw error
        } finally {
          this.$loadingService.close()
        }
      }).catch(() => {
        this.$notify.info('キャンセルしました。')
      })
    },
    cancel () {
      const cancelEdit = () => {
        this.updateMode(define.ROLE_MODE.NORMAL)
        this.$_ConfirmDiscardOnLeave_watchEnd()
        this.isChanged = false
      }
      if (!this.isChanged) {
        cancelEdit()
        return
      }
      this.$confirm('変更を破棄しますか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(() => {
        this.detailData = _.cloneDeep(this.originData)
        cancelEdit()
      }).catch(e => e)
    },
    /**
     * 権限ロール詳細情報を取得します。
     * @param {Boolean} [updateList=false] 一覧の情報を更新する場合、true
     */
    async getDetailData (updateList = false) {
      try {
        this.$loadingService.show()
        if (this.mode !== define.ROLE_MODE.NEW) {
          // 全権限データ取得
          let res = await common.postGraphQl(query.GRAPH_QL_QUERY_PERMISSION_ROLE_CONFIGS)

          let forSetData = {
            permissions: res.data.data.permissionConfigs.map((val) => {
              return { config: val }
            })
          }

          // 対象権限ロールのデータ取得
          res = await common.postGraphQl(query.GRAPH_QL_QUERY_PERMISSION_ROLE_DETAIL)

          // 結果が null の場合
          if (res.data.data.permissionRoles == null) {
            this.$notify.error({
              message: 'データを取得できませんでした。'
            })
            return
          }

          // 全権限に対して、対象権限ロールに紐づくデータがある場合、上書き
          let dbData = _.find(res.data.data.permissionRoles, (element) => element.uuid === this.$route.params.id)

          if (!this.$route.params.id) {
            // 高速でページが切り替わったとき「this.$route.params.id」が存在しないため、本チェックを行う
            return
          }
          if (!dbData) {
            this.$notify.error({
              message: 'データを取得できませんでした。'
            })
            return
          }
          // listIndexの更新
          this.$_detailUtil_onGetDetailData((element) => element.uuid === this.$route.params.id)

          forSetData.name = dbData.name
          forSetData.uuid = dbData.uuid
          dbData.permissions.forEach((permission) => { _.find(forSetData.permissions, (element) => element.config.key === permission.config.key).value = permission.value })
          forSetData.updatedAt = dbData.updatedAt

          this.detailData = forSetData
          this.$set(this.detailData, 'permissionValues',
            _.reduce(this.detailData.permissions, (acc, cur) => {
              // 非表示のvalueを2に変換する。データがないときは未選択状態「-1」にする。
              acc[cur.config.key] = (typeof cur.value === 'undefined') ? -1 : cur.value == null ? 2 : cur.value
              return acc
            }, {})
          )
        } else {
          const res = await common.postGraphQl(query.GRAPH_QL_QUERY_PERMISSION_ROLE_CONFIGS)

          this.detailData = {
            name: '',
            uuid: '',
            permissions: res.data.data.permissionConfigs.map((val) => {
              return { config: val }
            })
          }
          this.$set(this.detailData, 'permissionValues',
            _.reduce(this.detailData.permissions, (acc, cur) => {
              // 初期値「-1(未選択)」の設定
              acc[cur.config.key] = -1
              return acc
            }, {})
          )
        }

        this.originData = _.cloneDeep(this.detailData)

        // 一覧更新
        if (updateList) {
          this.updateListItem(this.detailData)
        }
      } catch (error) {
        throw error
      } finally {
        this.$loadingService.close()
      }
    },
    /**
     * 権限ロール登録 API または権限ロール更新 APIを呼び出す
     */
    async updateOrInsertPermissionRoleApi () {
      const url = this.mode === define.ROLE_MODE.NEW
        ? config.ROLE_PERMISSION_URL
        : config.ROLE_PERMISSION_URL + '/' + this.detailData.uuid
      const method = this.mode === define.ROLE_MODE.NEW ? 'post' : 'put'
      const permissions = _.chain(this.detailData.permissionValues)
        .entries()
        .map((val) => ({ key: val[0], value: val[1] === 2 ? null : val[1] }))
        .filter((element) => element.value !== -1)
        .value()
      const response = await common.apiAxios(url,
        {
          method,
          data: { name: this.detailData.name, permissions },
          heads: { 'X-CCS-Last-Updated-At': this.detailData.updatedAt }
        })
      return response
    },
    async deleteRoleApi () {
      const url = config.ROLE_PERMISSION_URL + '/' + this.detailData.uuid
      const method = 'delete'
      const response = await common.apiAxios(url, { method })
      return response
    },
    hasLastUpdatedError (error) {
      const code = _.get(error, 'response.data.code')
      if (code !== 400) {
        return false
      }
      return _.chain(error)
        .get('response.data.errors')
        .find(val => val.location === 'lastUpdatedAt' && val.reason === 'invalid')
        .value() != null
    },
    updateMode (mode) {
      this.$store.commit({
        type: 'set',
        states: {
          [`${this.storePath}/mode`]: mode
        }
      })
    },
    onBeforeUnload (event) {
      if (this.isChanged) {
        // 変更有の場合、再読み込み確認ダイアログを表示する.
        event.returnValue = 'changed'
      }
    },
    // 独自バリデーションチェック（表示されていない権限用）
    // エラー時は対象項目を表示するまで。メッセージは通常のバリデーションを使用
    async customRequiredEntirety () {
      const returnValue = await this.customRequired(
        _.map(this.detailData.permissions, element => element.config), true
      )
      if (!returnValue) {
        setTimeout(() => { this.$validator.validate() }, 400)
      }
      return returnValue
    },
    // 表示 または 編集にした際、子の権限の選択が必須である場合、親権限を展開してバリデーションチェックを行う
    async onChangePermission (event, path) {
      // 表示 または 編集
      if ([ 0, 1 ].includes(event)) {
        const targetPermission = this.detailData.permissions.find((element) => `permissionValues.${element.config.key}` === path)
        const returnValue = await this.customRequired(targetPermission.config.children, false)
        // 子のバリデーションチェックを行う
        if (!returnValue) {
          setTimeout(() => {
            targetPermission.config.children.forEach((permission) => {
              this.$validator.validate(`permissionValues.${permission.key}`)
            })
          }, 400)
        }
        return returnValue
      } else {
        // 子のバリデーションチェックを行う
        const targetPermission = this.detailData.permissions.find((element) => `permissionValues.${element.config.key}` === path)
        targetPermission.config.children.forEach(async (permission) => {
          try {
            await this.$validator.validate(`permissionValues.${permission.key}`)
          } catch (error) { // 子のアイテムが開かれていないとき、エラーとなるため握りつぶす。バリデーションエラー時は子が開かれ、エラーメッセージが表示されるため、問題なし。
          }
        })

        return true
      }
    },
    async customRequired (rootPermissions, isFocus) {
      let result = true
      await rootPermissions.forEach(async (targetPermission) => {
        // edit_typeが「2」である
        if (targetPermission.editType === 2) {
          // 値が未選択である
          if (this.detailData.permissionValues[targetPermission.key] === -1) {
            // 親の項目が「0」または「1」である
            if ([ 0, 1 ].includes(this.detailData.permissionValues[targetPermission.parent.key])) {
              result = false
              // 項目の表示
              const openTree = async (key) => {
                const targetOptionLabel = document.getElementById(key)
                if (targetOptionLabel) {
                  const targetOptionRow = targetOptionLabel.parentNode.parentNode
                  // ツリーが開いていなければ開く
                  const attr = targetOptionRow.attributes['aria-expanded']
                  if (attr == null) {
                    const targetOpenTag = targetOptionLabel.parentNode.getElementsByClassName('el-tree-node__expand-icon')
                    targetOpenTag[0].click()
                    if (isFocus) {
                      setTimeout(async () => {
                        window.scrollTo(window.scrollX, window.scrollY + targetOptionRow.getBoundingClientRect().top - 200)
                      }, 500)
                    }
                  }
                } else {
                  setTimeout(async () => {
                    await openTree(key)
                  }, 2)
                }
              }
              // 開いている項目まで再起呼び出しで表示
              const openTreeError = async (parentNode) => {
                // さらに親がいるのであれば再起呼び出しを行う
                if (parentNode.parent !== null) {
                  const targetPermission = this.detailData.permissions.find((element) => element.config.key === parentNode.parent.key)
                  await openTreeError(targetPermission.config)
                }

                await openTree(parentNode.key)
              }
              await openTreeError(targetPermission)
            }
          }
        }
      })
      return result
    }
  }
}
</script>
